
<template lang="pug">
  .sidecart__line-item(v-if="item", :class="itemClass" :style="orderStyle")
    .sidecart__line-item__image-wrapper
      a(:href="item.url")
        img.sidecart__line-item__image(:src="item.image | image('220x')" :alt="item.product_title")
    .sidecart__line-item__content
      .sidecart__line-item__header
        .sidecart__info
          a(:href="item.url")
            p.sidecart__line-item__title(v-html="itemName")
          div.sidecart__line-item__list 
            p.sidecart__line-item__option.p-m(
              v-for="option in formattedProductOptions" 
            ) {{ `${Object.values(option)}`.toLowerCase() }}
          div.sidecart__line-item__list
            span.sidecart__line-item__list__price--discount(v-if="isFinalSale") Final Sale (No Returns or Exchanges)
        icon-button.sidecart__line-item__remove(label="Remove", icon="icon-remove", @click="removeItem")
      .sidecart__line-item__details
        .sidecart__line-item__quantity
          icon-button.sidecart__line-item__quantity__change(label="Decrement Count", icon="icon-minus", @click="decrement")
          p.sidecart__line-item__quantity__label.p-mono {{ item.quantity }}
          icon-button.sidecart__line-item__quantity__change(label="Increment Count", icon="icon-plus", size="9px",  @click="increment")
        p.sidecart__line-item__price
          span.p-m.sidecart__line-item__price--compare-at(v-if="isDiscounted || isGiftWithPurchase") {{ isGiftWithPurchase ? item.line_price : comparePrice | money }}
          span.p-m(v-if="!isGiftWithPurchase", :class="{ 'sidecart__line-item__price--discount': isDiscounted }") {{ item.line_price | money }}
          span.p-m.sidecart__line-item__price--discount
      .sidecart__line-item__message(v-for="discount in item.discounts")
        | {{ discount.title }}
</template>

<script>
  import { mapState } from 'vuex'
  import { debounce } from '../../utils/utils.js'
  import { money, moneyWithoutTrailingZeros } from '../../filters/money.js';
  
  import IconButton from '../buttons/IconButton.vue'



  export default {
    name: 'SidecartLineItem',
    components: { IconButton },
    props: {
      item: Object,
      line: Number,
      order: Number
    },
    data () {
      return {
        updating: false,
        removing: false,
        removeTimeout: null
      }
    },
    computed: {
      ...mapState({

      }),
      orderStyle(){
        return `order: ${this.order}`;
      },
      itemClass () {        
        return {
          'updating': this.updating
        }
      },
      
      isFinalSale () {
        return this.product && !!this.product.sale_no_returns;
      },
      variant () {
        return this.product ? this.product.variants.find(variant => variant.id === this.item.id) : null
      },
      itemName () {
        if(this.baseProduct) {
          const freq = this.item.properties.shipping_interval_frequency
          const unit = this.item.properties.shipping_interval_unit_type

          return `${this.item.product_title} - ${freq} ${unit} Subscription`;
        }

        return this.item.product_title.replaceAll('®', '<sup>®</sup>');
      },
      comparePrice () {
        if(this.baseProduct) {
          return this.baseProduct.price * this.item.quantity;
        }

        return (this.variant) ? parseInt(this.variant.compare_at_price, 10) * this.item.quantity : this.item.price * this.item.quantity
      },
      isDiscounted () {
        return this.item.price !== this.comparePrice && !isNaN(this.comparePrice)
      },
      formattedProductOptions() {
        let formattedProductOptions = [];
        const productOptions = this.item.options_with_values;

        const options = productOptions.map(function(option) {
          const optionName = option.name;
          const optionValue = option.value;

          if (optionName !== 'Title' && optionValue !== 'NO COLOR' && optionValue !== 'N/A' && optionValue !== 'NS') {
            formattedProductOptions.push({
              [optionName]: optionValue,
            });
          }
        });
        return formattedProductOptions;
      },
      isGiftWithPurchase () {
        return Boolean(this.item.properties && this.item.properties._gwp)
      }
    },
    methods: {
      removeItem () {
        if (this.isGiftWithPurchase) {
          localStorage.setItem('gwpRemoved', 'true')
        }
        this.$store.dispatch('cart/removeItem', this.line)
          .catch(error => this.$store.dispatch('toast/send', { text: error, type: 'error' }))
          .then(() => this.removing = false)
      },
      increment () {
        this.updateQuantity(this.item.quantity + 1)
      },
      decrement () {
        if (this.item.quantity > 0) {
          this.updateQuantity(this.item.quantity - 1)
        }
      },
      updateQuantity: debounce(function (newQuantity) {
        this.updating = true

        if (newQuantity < 1) {
          this.removeItem()
          return
        }

        this.$store.dispatch('cart/updateItem', { line: this.line, quantity: newQuantity })
          .catch(error => this.$store.dispatch('toast/send', { text: error, type: 'error' }))
          .then(() => this.updating = false)
      }, 100),
      undoRemove() {
        clearTimeout(this.removeTimeout)
        this.removing = false
        this.updating = false
      }
    },
    created () { 
      window.addEventListener('beforeunload', () => { 
        if(this.removing) { 
          this.removeItem(); 
        }
      })


    }
  }
</script>

<style scoped lang="scss">
</style>